import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import {TelephoneService} from './telephone.service';

@Directive({ selector: '[appTelephoneFormatter]' })
export class AppTelephoneFormatterDirective implements OnInit {

  constructor(
    private elementRef: ElementRef,
    private _telephoneService: TelephoneService
  ) {}

  ngOnInit() {
  }

  @HostListener('input', ['$event'])
  onFocus(event: KeyboardEvent) {
    const el: HTMLInputElement = (event.target as HTMLInputElement);
    this._telephoneService.applyValueChanges(el);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: any) {
  }

}



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shared/telephone-mask/telephone.directive.ts